/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Allocation_PeriodInputs */

const cs_billing_allocation_period = /** @type {(inputs: Billing_Allocation_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Období`)
};

const en_billing_allocation_period = /** @type {(inputs: Billing_Allocation_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period`)
};

/**
* | output |
* | --- |
* | "Period" |
*
* @param {Billing_Allocation_PeriodInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_allocation_period = /** @type {((inputs?: Billing_Allocation_PeriodInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Allocation_PeriodInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_allocation_period(inputs)
	return cs_billing_allocation_period(inputs)
});